import type { FC } from 'react'
import type React from 'react'
import { useState, useContext } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import TextAreaInput from '@/components/input/TextAreaInput'
import ctx from '@/context/AppContext'
import { useReopenSectionsMutation } from '@/lib/apollo/mutation/reopen-sections'
import { Colours } from '@/utils/styles'

import type { SectionName } from './types'

const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`

const StyledTextAreaInput = styled(TextAreaInput)`
  height: 300px;
`

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  sectionName: SectionName
  onClose: () => void
}

const ReopenSectionPanel: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  sectionName,
  onClose,
}) => {
  const [error, setError] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const [comment, setComment] = useState<string>('')

  const { personId } = useContext(ctx)

  const [handleReopenSections] = useReopenSectionsMutation()

  const onSubmit = async () => {
    setError(undefined)
    setLoading(true)

    try {
      await handleReopenSections({
        variables: {
          customerId,
          applicationId,
          subjectId,
          sections: [
            {
              name: sectionName,
              comment,
            },
          ],
          userId: personId ?? '',
        },
      })

      setSuccess(true)
    } catch (e) {
      setError('An unexpected error occurred.')
    }

    setLoading(false)
  }

  return (
    <SlideInSidebar
      onClose={() => onClose()}
      header={<h1>Reopen {sectionName} section</h1>}
      content={
        success ? (
          <>This section has been reopened.</>
        ) : (
          <>
            <>Would you like to reopen this section?</>
            <StyledTextAreaInput
              label="Comments"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setComment(e.target.value)
              }}
              value={comment}
            />
          </>
        )
      }
      footer={
        <>
          {error && <ErrorContainer>{error}</ErrorContainer>}
          <div>
            <AlternateButton onClick={onClose}>Cancel</AlternateButton>
            {!success && (
              <Button disabled={loading} onClick={onSubmit}>
                Confirm
              </Button>
            )}
          </div>
        </>
      }
    />
  )
}

export default ReopenSectionPanel
